export class SetInitalizedSite {
  static readonly type = '[Site] Set Initalized';
}

export class ToggleOffcanvasSite {
  static readonly type = '[Site] Toggle Offcanvas';
  constructor(public close: boolean = false) {}
}

export class ToggleMenuSite {
  static readonly type = '[Site] Toggle Menu';
}

export class ShowLoadingSite {
  static readonly type = '[Site] Show Loading';
}

export class HideLoadingSite {
  static readonly type = '[Site] hide Loading';
}
